import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 26,
	viewBox: "0 0 25 26",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.7292 22.3491L13.8802 15.5002C13.3594 15.9516 12.7521 16.3031 12.0584 16.5548C11.3646 16.8066 10.6264 16.9325 9.84375 16.9325C7.96594 16.9325 6.37669 16.2814 5.07602 14.9793C3.77534 13.6772 3.125 12.1061 3.125 10.2658C3.125 8.42551 3.77604 6.85433 5.07812 5.55225C6.38021 4.25016 7.95573 3.59912 9.80469 3.59912C11.6536 3.59912 13.2248 4.25016 14.5182 5.55225C15.8116 6.85433 16.4583 8.42681 16.4583 10.2697C16.4583 11.0136 16.3368 11.7328 16.0938 12.4272C15.8507 13.1217 15.4861 13.7727 15 14.3804L21.875 21.2033L20.7292 22.3491ZM9.81771 15.37C11.2283 15.37 12.4273 14.8708 13.4147 13.8726C14.4021 12.8743 14.8958 11.672 14.8958 10.2658C14.8958 8.85954 14.4021 7.65728 13.4147 6.65902C12.4273 5.66075 11.2283 5.16162 9.81771 5.16162C8.39266 5.16162 7.18135 5.66075 6.1838 6.65902C5.18627 7.65728 4.6875 8.85954 4.6875 10.2658C4.6875 11.672 5.18627 12.8743 6.1838 13.8726C7.18135 14.8708 8.39266 15.37 9.81771 15.37Z",
		fill: "#118AB2"
	})
});
export default SvgSearch;
